import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import Spinner from 'components/shared/Spinner'
import Checkbox from 'components/shared/Checkbox'
import { useSelector, useDispatch } from 'react-redux'
import * as Selectors from 'state/selectors'
import * as Actions from 'state/actions'
import { setTitleByChannelName } from 'shared/utils/titles'

import TopBar from './TopBar'

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  padding: 40px 30px;
`
const InboxesWrapper = styled.div`
  overflow-y: auto;
  max-height: 100%;
  margin-top: 10px;
  padding-bottom: 100px;
`
const ItemWrapper = styled.div``
const Title = styled.div`
  font-size: 20px;
  font-weight: 700;
`
const ItemTitle = styled.div`
  font-size: 16px;
`
const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
`
const uncheckedStyles = props => props.checked === false && css`
  opacity: .7;
`
const InboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  max-width: 480px;
  margin-top: 10px;
  margin-bottom: 10px;
  
  cursor: pointer;
  transition: opacity .3s ease;
  
  ${uncheckedStyles}
`
const checkboxStyles = css`
  margin-right: 10px;
`

const Inboxes = () => {
  const dispatch = useDispatch()
  const toggleCheckbox = ({ itemIndex, inboxIndex }) => () => {
    dispatch(Actions.settingsInboxesOnToggle({ itemIndex, inboxIndex }))
  }

  const settingsInboxesState = useSelector(Selectors.getSettingsInboxesState)
  const isSessionRequesting = useSelector(Selectors.getSessionIsRequesting)
  const isSettingsRequesting = settingsInboxesState.isRequesting

  const {
    collection
  } = settingsInboxesState
  
  return (
    <Wrapper>
      { (isSettingsRequesting || isSessionRequesting) && <Spinner /> }

      <TopBar />

      <InboxesWrapper>

        {
          collection.map((item, itemIndex) => (
            <ItemWrapper key={itemIndex}>
              <Title>{ item.agentName }</Title>

              {
                item.inboxes.map((inbox, inboxIndex) => (
                  <InboxWrapper
                    key={inboxIndex}
                    checked={inbox.checked}
                    onClick={toggleCheckbox({itemIndex, inboxIndex})}
                  >
                    <CheckboxWrapper>
                      <Checkbox
                        customStyles={checkboxStyles}
                        checked={inbox.checked}
                      />
                      <ItemTitle>{ inbox.title }</ItemTitle>
                    </CheckboxWrapper>

                    {
                      (inbox.inboxType === 'channelId' && inbox?.meta?.channelName) &&
                      <ItemTitle>{ setTitleByChannelName(inbox.meta.channelName) }</ItemTitle>
                    }
                  </InboxWrapper>
                ))
              }

            </ItemWrapper>
          ))
        }
      </InboxesWrapper>

    </Wrapper>
  )
}

export default Inboxes
